import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js';

import { Vue3JsonEditor } from 'vue3-json-editor'
import SimpleTypeahead from 'vue3-simple-typeahead';

let app = createApp(App);
app.component('Vue3JsonEditor', Vue3JsonEditor);
app.component('SimpleTypeahead', SimpleTypeahead);

app.mount('#app');